import Vue from 'vue'
import ServerEvents from "@/server/ServerEvents";

class _EventBus{
    constructor() {
        this.vue = new Vue();
        this.subscribed = 0;
        this.triggers = new Map();
        this.listeners = new Map();

        this.subscriptionsPerInstance = [];

        this.callbackIdCounber = 0;
        this.uuidToCallbacks = {};
        this.routesToEvUuids = {};
        this.callbackIdToServerUuid = {};

        this.vue.$on(ServerEvents.observableEntityChange, (observableEntityChange => {
           window['Log'].debug("Processing... observableEntityChange");
            this.processTriggers(observableEntityChange);
        }));
        this.vue.$on(ServerEvents.dynamicEntityChange, (dynamicEntity => {
            window['Log'].debug("Processing... dynamicEntityChange");
            this.processTriggers(dynamicEntity);
        }));

    }

    async $subscribe(routingKey, callback){
        let uuid = await Rpc.Subscribable.subscribe(routingKey);
        this.uuidToCallbacks[uuid] = {callback, routingKey};
        if(!this.routesToEvUuids[routingKey]){
            this.routesToEvUuids[routingKey] = new Set();
        }
        this.routesToEvUuids[routingKey].add(uuid);

        let id = this.callbackIdCounber++;
        this.callbackIdToServerUuid[id] = uuid;
        Log.info(`Subscribed to ${routingKey}: ${id}`);

        return id;
    }

    async $unsubscribe(id){
        Log.info(`Unsubscribing: ${id}`);
        if(!this.callbackIdToServerUuid[id]){
            return;
        }
        let uuid = this.callbackIdToServerUuid[id];

        let routingKey = this.uuidToCallbacks[uuid].routingKey;
        this.routesToEvUuids[routingKey].delete(uuid);

        if(this.routesToEvUuids[routingKey].size === 0){
            delete this.routesToEvUuids[routingKey];
        }

        delete this.uuidToCallbacks[uuid];
        delete this.callbackIdToServerUuid[id];
        await Rpc.Subscribable.unsubscribe(uuid);
    }

    async recoverAfterWsFailure(){
        for(let id in this.callbackIdToServerUuid){
            let oldUid = this.callbackIdToServerUuid[id];
            let routing = this.uuidToCallbacks[oldUid].routingKey;
            let newUuid = await Rpc.Subscribable.subscribe(routing);

            if(this.routesToEvUuids[routing] && this.routesToEvUuids[routing].has(oldUid)) {
                this.routesToEvUuids[routing].delete(oldUid);
            }

            if(this.callbackIdToServerUuid[id]){
                this.callbackIdToServerUuid[id] = newUuid;
                this.uuidToCallbacks[newUuid] = this.uuidToCallbacks[oldUid];
                delete this.uuidToCallbacks[oldUid];

                if(!this.routesToEvUuids[routing]){
                    this.routesToEvUuids[routing] = new Set();
                }
                this.routesToEvUuids[routing].add(newUuid);

            } else{
                await Rpc.Subscribable.unsubscribe(newUuid);
            }
        }

    }

    $on(){
        this.subscribed++;
        this.vue.$on.apply(this.vue, arguments);
    }
    $once(){
        this.vue.$once.apply(this.vue, arguments);
    }
    $off(){
        this.subscribed--;
        this.vue.$off.apply(this.vue, arguments);
    }
    $emit(eventType, event){
        if(eventType === ServerEvents.subscribedMessage){
            if(this.routesToEvUuids[event.routingKey]){
                for(let uuid of this.routesToEvUuids[event.routingKey]){
                    console.log("Processing subscribed event");
                    this.uuidToCallbacks[uuid].callback(event.data);
                }
            }
            return;
        }
        this.vue.$emit.apply(this.vue, arguments);
    }
    registerEvent(eventType, owner, callback){
        if(!this.listeners.has(eventType)){
            this.listeners.set(eventType, new Set());
            const that = this;
            this.$on(eventType, function() {
                that.processEvent(eventType, arguments);
            });
        }
        let set = this.listeners.get(eventType);

        /** @type {Set} */
        set.add({owner, callback});
        window['Log'].debug("Registering listener for: " + eventType);

    }

    async registerSubscription(routingKey, owner, callback){
        let id = await this.$subscribe(routingKey, callback);
        this.subscriptionsPerInstance.push({owner, id});
        return id;
    }

    registerTrigger(entityClass, owner, callback){
        if(!this.triggers.has(entityClass)){
            this.triggers.set(entityClass, new Set());
        }
        let set = this.triggers.get(entityClass);

        /** @type {Set} */
        set.add({owner, callback});
        window['Log'].debug("Registering trigger for: " + entityClass);
    }

    unregisterAllTriggers(owner){
        let remainSubs = [];
        for(let registration of this.subscriptionsPerInstance){
            if(registration.owner === owner){
                this.$unsubscribe(registration.id);
            } else {
                remainSubs.push(registration);
            }
        }
        this.subscriptionsPerInstance = remainSubs;

        for(const map of [this.triggers, this.listeners]) {
            map.forEach(/** @type {Set} */(setOfListeners, entityOrEventId) => {
                setOfListeners.forEach(listener => {
                    if (listener.owner == owner) {
                        window['Log'].debug("Unregistering listener for: " + entityOrEventId);
                        setOfListeners.delete(listener);
                    }
                })
            })
        }
    }

    processEvent(eventType, args){
        if(this.listeners.has(eventType)){
            this.listeners.get(eventType).forEach(listener => {
                try {

                    //window['Log'].debug("Calling event listener for: " + eventType);
                    listener.callback.apply(listener.owner, args);
                } catch (e){
                    window['Log'].fatal(e);
                }
            });
        };

    }

    /**
     * @param {ObservableEntityChange|DynamicEntityChange} observableEntityChange
     */
    processTriggers(observableEntityChange){
        let clazz = observableEntityChange.entityType;
        let longClazz = observableEntityChange.entityLongType;
        window['Log'].debug(`processTriggers: ${clazz}, ${longClazz}`);

        for(const name of [clazz, longClazz]){
           window['Log'].debug(`forOf: ${name}`);

            if(this.triggers.has(name)){
               window['Log'].debug(`trigger pros ${name}`);
                this.triggers.get(name).forEach(listener => {
                   window['Log'].debug(`trigger pros ${name} forEach - step`);

                    try {
                        window['Log'].debug("Triggering listener for: " + name);
                        listener.callback.apply(listener.owner, [observableEntityChange]);
                    } catch (e){
                       window['Log'].debug(`FATAL ${e}`);
                        window['Log'].fatal(e);
                    }
                });
            };
        }
    }

}

const EventBus = new _EventBus();
window["EventBus"] = EventBus;
export default EventBus;


